import MuiCheckbox from './muiCheckbox'
export default MuiCheckbox
